import { Component, Input, OnChanges, ChangeDetectionStrategy } from "@angular/core";
import { BHR } from "@onsip/common/interfaces/bhr";
import { TranslateService } from "@ngx-translate/core";

type Day = "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday";
interface FormattedBHRDay {
  day: string;
  start: Date;
  end: Date;
  disabled: boolean;
}

@Component({
  selector: "onsip-bhr-list-view",
  templateUrl: "./bhr-list-view.component.html",
  styleUrls: ["../sayso-topic-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BHRListViewComponent implements OnChanges {
  @Input() bhr: BHR | undefined;
  dayAbbreviations: Record<string, string> = {};
  formattedBhr: Array<FormattedBHRDay> = [];

  constructor(private translate: TranslateService) {}

  ngOnChanges() {
    if (this.bhr) {
      this.formattedBhr = [];
      Object.keys(this.bhr).forEach((key: string) => {
        if (key !== "enabled" && key !== "timezone" && key !== "holidays") {
          const dayKey: Day = key as Day;
          const day = (this.bhr as BHR)[dayKey];
          const start: Date = new Date();
          const end: Date = new Date();
          start.setHours(day.start.h, day.start.m);
          end.setHours(day.end.h, day.end.m);
          this.formattedBhr.push({
            day: this.getDayAbbreviation(dayKey),
            start,
            end,
            disabled: day.disabled
          });
        }
      });
    }
  }

  private getDayAbbreviation(day: Day): string {
    switch (day) {
      case "monday":
        return this.translate.instant("ONSIP_I18N.MON");
      case "tuesday":
        return this.translate.instant("ONSIP_I18N.TUES");
      case "wednesday":
        return this.translate.instant("ONSIP_I18N.WED");
      case "thursday":
        return this.translate.instant("ONSIP_I18N.THURS");
      case "friday":
        return this.translate.instant("ONSIP_I18N.FRI");
      case "saturday":
        return this.translate.instant("ONSIP_I18N.SAT");
      case "sunday":
        return this.translate.instant("ONSIP_I18N.SUN");
      default:
        throw Error("BHRListView: must pass type of Day");
    }
  }
}
